//   function showAnswer(clickedElement) {
//     const faqTitle = document.querySelectorAll('.accordion-header');
//     faqTitle.forEach((element) => {
//       element.classList.remove('active');
//     });
//     clickedElement.classList.add('active');
//   }
function toggleAnswer(clickedElement) {
    const isActive = clickedElement.classList.contains('active');

    // close all in starting
    const faqHeader = document.querySelectorAll('.accordion-header');
    faqHeader.forEach((elm) => elm.classList.remove('active'));

    // If it wasn't active, open it
    if (!isActive) {
        clickedElement.classList.add('active');
    }
}